import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../../actions/commonActions";
import { FETCH_VALUE_SELLING_CARD_REQUEST, FETCH_VALUE_SELLING_CARD_SUCCESS, FETCH_VALUE_SELLING_CARD_FAILURE } from "../../actions/opportunities/valueSellingCardActions";


  const initialState = {
    valueSellingCardLoading: false,
    valueSellingCardData: [],
    valueSellingCardError: null,
  };
  
  const valueSellingCardReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_VALUE_SELLING_CARD_REQUEST:
        return { ...state, valueSellingCardLoading: true , payload: action.payload};
      case FETCH_VALUE_SELLING_CARD_SUCCESS:
        return { ...state, valueSellingCardLoading: false, valueSellingCardData: action.payload };
      case FETCH_VALUE_SELLING_CARD_FAILURE:
        return { ...state, valueSellingCardLoading: false, valueSellingCardError: action.payload };      
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
              return initialState      
      default:
        return state;
    }
  };
  
  export default valueSellingCardReducer;
  